import React from "react";

/* Components */
import Navigation from "./components/Navigation/Navigation";
import Footer from "./components/Footer/Footer";

export default class App extends React.Component {
    showSettings(event) {
        event.preventDefault();
    }

    render() {
        return (
            <div className="outer-container" id="outer-container">
                <Navigation />
                <Footer />
            </div>
        );
    }
}
